import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {EmailComponent} from "./email/email.component";
import {ConfiguracaoEmailComponent} from "./configuracao-email/configuracao-email.component";
import {WhatsappComponent} from "./whatsapp/whatsapp.component";

const routes: Routes = [
  {
    path: 'email',
    component: EmailComponent
  },
  {
    path: 'whatsapp',
    component: WhatsappComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComunicacaoRoutingModule { }
